import * as Yup from "yup";

export const slabRangeSchema = Yup.object().shape({
  range_income_from: Yup.string().required("Income From is required"),
  range_income_to: Yup.string().required("Income To is required"),
  range_calculation_mode: Yup.string()
    .oneOf(["fixed", "percentage"])
    .required("Calculation mode is required"),
  range_fixed_amount: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .min(0, "Cannot be negative")
    .when("range_calculation_mode", {
      is: "fixed",
      then: (schema) =>
        schema
          .typeError("Fixed amount is required")
          .required("Fixed amount is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  range_percentage: Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .min(0, "Cannot be negative")
    .when("range_calculation_mode", {
      is: "percentage",
      then: (schema) =>
        schema
          .typeError("Percentage is required")
          .required("Percentage is required"),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const slabRuleSchema = Yup.object().shape({
  slab_name: Yup.string().required("Slab name is required"),
  slab_description: Yup.string(),
  slab_range: Yup.array()
    .of(slabRangeSchema)
    .min(1, "At least one range required"),
});

export const validationSchema = Yup.object().shape({
  tax_type_code: Yup.string().required("Tax type code is required"),
  tax_type_name: Yup.string().required("Tax type name is required"),
  effective_from: Yup.string().required("Effective from is required"),
  effective_to: Yup.string().nullable(),
  calculation_type: Yup.string()
    .oneOf(["fixed", "percentage", "slab"])
    .required("Calculation type is required"),
  applicable_countries: Yup.array()
    .of(
      Yup.object().shape({
        country_id: Yup.string().required("Country is required"),
        country_active: Yup.boolean(),
        effective_from: Yup.string()
          .nullable()
          .required("Effective from is required"),
        effective_to: Yup.string().nullable(),
      })
    )
    .min(1, "At least one country required"),
  fixed_amount: Yup.number()
    .min(0, "Cannot be negative")
    .when("calculation_type", (val, schema) =>
      typeof val === "string" && val === "fixed"
        ? schema.typeError("Required").required("Fixed amount is required")
        : schema.nullable()
    ),
  percentage_rate: Yup.number()
    .min(0, "Cannot be negative")
    .when("calculation_type", (val, schema) =>
      typeof val === "string" && val === "percentage"
        ? schema.typeError("Required").required("Percentage rate is required")
        : schema.nullable()
    ),
  slab_rule: Yup.array()
    .of(slabRuleSchema)
    .when("calculation_type", (val, schema) =>
      typeof val === "string" && val === "slab"
        ? schema.min(1, "At least one slab rule required")
        : schema.nullable()
    ),
  tax_type_description: Yup.string(),
});
